import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function OperatorDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Operator Details"}
                            editHref={"/operator/update"}
                            endpoint={"operator/read"}
                            relations={["operator", "operator_game_configs.game_config", "casinos", "operator_game_configs.game_config.provider", "tenants"]}
                            manyToManyRelations={[
                                {
                                name: "tenants",
                                title: "Tenants",
                                columnTitles: ["Id", "Name", "external_id"],
                                objectKeys: ["id", "name", "external_id"],
                                attachHref: {
                                    href: "/operator-tenant/create",
                                    title: "Attach Tenats"
                                }},
                                {
                                name: "operator_game_configs",
                                title: "Operator Game Configs",
                                columnTitles: ["GameId", "Game Name", "Internal Game ID", "Vendor Game ID"],
                                objectKeys: ["game_config.id", "game_config.name", "internal_game_id", "provider_game_id"],
                                attachHref: {
                                    href: "/operator/game-config/attach",
                                    title: "Attach Game"
                                }
                            }]}
                            oneToManyRelations={[
                                {
                                    title: "Casinos",
                                    columnTitles: [
                                        "ID", "Company Name", "Partner ID", "Type", "Lobby URL", "Email"
                                    ],
                                    objectKeys: ["id", "company_name", "partner_id", "type", "lobby_url", "email"],
                                    name: "casinos",
                                    detailsHref: "/operator/details"
                                }
                            ]} />
}

export default OperatorDetailsPage;